import { Divider, Stack, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

import { useTranslate } from "src/locales";

const FallRiskHarizmiFooter = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const { t } = useTranslate();

    return (
        <Stack
            direction={"row"}
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
        >
            <Stack>
                <Tabs
                    className="ByzMuiTabs"
                    sx={{
                        marginBottom: 2,
                    }}
                    value={selectedTab}
                    onChange={(event, newValue) => setSelectedTab(newValue)}
                    aria-label="Tabs"
                >
                    <Tab label={t("fall-risk-harizmi.footer-tab-preventive")} value={0} />
                    <Tab label={t("fall-risk-harizmi.footer-tab-post-fall")} value={1} />
                </Tabs>

                {selectedTab === 0 ? (
                    <ByzMuiTypography
                        sx={{
                            fontSize: 13,
                            fontWeight: 400,
                            whiteSpace: "pre-line",
                            wordWrap: "break-word",
                            margin: 0,
                        }}
                    >
                        {t("fall-risk-harizmi.footer-content-preventive")}
                    </ByzMuiTypography>
                ) : (
                    <ByzMuiTypography
                        sx={{
                            fontSize: 13,
                            fontWeight: 400,
                            whiteSpace: "pre-line",
                            wordWrap: "break-word",
                            margin: 0,
                        }}
                    >
                        {t("fall-risk-harizmi.footer-content-post-fall")}
                    </ByzMuiTypography>
                )}
            </Stack>

            <ByzMuiTypography
                sx={{
                    fontSize: 13,
                    fontWeight: 400,
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
                    margin: 0,
                    mt: 4,
                }}
            >
                {t("fall-risk-harizmi.footer-content-extra")}
            </ByzMuiTypography>
        </Stack>
    );
};

export default FallRiskHarizmiFooter;
